module.exports = {
      id: "sort-usage",
      viewBox: "0 0 6 8",
      url: "/" + "sprite-036dd45d0e77a995aefc8cbeaab2becc.svg#sort",
      toString: function () {
        return this.url;
      }
    }